var BranchEnum = /* @__PURE__ */ ((BranchEnum2) => {
  BranchEnum2["BUTTON_SHOW_MORE_SPECIALTIES"] = "branch-specialties-show-more-button--professional-about";
  BranchEnum2["BUTTON_SHOW_MORE_EXAMS"] = "branch-exams-show-more-button--professional-about";
  BranchEnum2["BRANCH_PROFILE_SECTION_ADDRESS"] = "branch-profile--section-address";
  BranchEnum2["BRANCH_PROFILE_SECTION_OPENING_HOURS"] = "branch-profile--section-opening-hours";
  BranchEnum2["BRANCH_PROFILE_SECTION_SPECIALTIES"] = "branch-profile--section-specialties";
  BranchEnum2["BRANCH_PROFILE_SECTION_EXAMS"] = "branch-profile--section-exams";
  BranchEnum2["BRANCH_PROFILE_SECTION_PAYMENT_METHODS"] = "branch-profile--section-payment-methods";
  BranchEnum2["BRANCH_PROFILE_SECTION_STRUCTURE"] = "branch-profile--section-structure";
  BranchEnum2["BRANCH_PROFILE_SECTION_SOCIAL_MEDIA"] = "branch-profile--section-social-media";
  BranchEnum2["BRANCH_PROFILE_SECTION_CONTACTS"] = "branch-profile--section-contacts";
  BranchEnum2["BRANCH_PROFILE_SPECIALTIES_LIST"] = "branch-specialties--item-list";
  BranchEnum2["BRANCH_PROFILE_EXAMS_LIST"] = "branch-exams--item-list";
  BranchEnum2["BRANCH_PROFILE_OPENING_HOURS_LIST"] = "branch-opening-hours-list";
  BranchEnum2["BRANCH_CARD"] = "branch-card";
  BranchEnum2["BRANCH_CARD_LINK"] = "branch-card-link";
  BranchEnum2["BRANCH_CONTACT_EMAIL"] = "branch-contact--email";
  BranchEnum2["BRANCH_CONTACT_PHONE"] = "branch-contact--phone";
  BranchEnum2["BRANCH_CONTACT_WHATSAPP"] = "branch-contact--whatsapp";
  BranchEnum2["BRANCH_CONTACT_WHATSAPP_BUTTON"] = "branch-contact--whatsapp-button";
  BranchEnum2["BRANCH_CONTACT_SOCIAL_MEDIA_FACEBOOK"] = "branch-contact--social-media-facebook";
  BranchEnum2["BRANCH_CONTACT_SOCIAL_MEDIA_INSTAGRAM"] = "branch-contact--social-media-instagram";
  BranchEnum2["BRANCH_CONTACT_INFORMATION_CARD"] = "branch-contact-information--card";
  return BranchEnum2;
})(BranchEnum || {});
export {
  BranchEnum
};
